import { usePathsV2 } from 'core/services/navigation/usePathsV2';
import { CandidateProfileList } from 'modules/candidate-profile/components/CandidateProfileList';
import { VisibleTalentListGate } from 'modules/candidate-profile/components/VisibleTalentListGate';
import {
  CandidateProfileListProps,
  CandidateProfileListType
} from 'modules/candidate-profile/types/CandidateProfileListProps';

export const TalentPoolDetails: React.FC = () => {
  const { getPathParams } = usePathsV2();
  const { talentPoolId } = getPathParams.TALENT_POOL_DETAILS();
  const props: CandidateProfileListProps = {
    type: CandidateProfileListType.CANDIDATES_FROM_TALENT_POOL,
    talentPoolId
  };

  return (
    <VisibleTalentListGate
      talentPoolId={talentPoolId}
      candidateProfileListProps={props}
    >
      <CandidateProfileList {...props} />
    </VisibleTalentListGate>
  );
};
